__turbopack_context__.v({
  "buttons": "EpodwG_buttons",
  "count": "EpodwG_count",
  "input": "EpodwG_input",
  "label": "EpodwG_label",
});
